module.exports = __webpack_public_path__ + "static/media/unsucessful.2a95c039.svg";